// extracted by mini-css-extract-plugin
module.exports = {"moreUnreadNewsPillRoot":"WpTP30TI"};